import { choose } from '../../utils/platform';
import FunctionFormDesktop from './FunctionForm.desktop';
import FunctionFormMobile from './FunctionForm.mobile';

// Platform chooser: phone (APK or narrow browser) gets the full-screen variant.
export default choose(FunctionFormDesktop, FunctionFormMobile);
